import { reactive, readonly, toRefs } from 'vue'

const state = reactive({
  fieldErrorKeys: [],
})

export const giftFieldErrorKeys = readonly(toRefs(state).fieldErrorKeys)

export const setGiftFieldErrorKey = (key, remove = false) => {
  if (remove) {
    const index = state.fieldErrorKeys.indexOf(key)
    if (index > -1) {
      state.fieldErrorKeys.splice(index, 1)
    }
  } else if (!state.fieldErrorKeys.includes(key)) {
    state.fieldErrorKeys.push(key)
  }
}
